import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
  type PropsWithChildren,
} from 'react';
import React from 'react';

interface ToolbarVisibilityContext {
  isShowing: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}
const context = createContext<ToolbarVisibilityContext>({
  isShowing: false,
  onMouseEnter: () => {},
  onMouseLeave: () => {},
});
context.displayName = 'ToolbarVisibilityContext';

export const useToolbarVisiblityState = () => useContext(context);

export const ToolbarVisibilityProvider = ({
  alwaysShow,
  children,
}: PropsWithChildren<{ alwaysShow?: boolean }>) => {
  const [isShowing, setIsShowing] = useState(true);

  const timer = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    timer.current = setTimeout(() => {
      setIsShowing(false);
    }, 2000);
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  const onMouseEnter = useCallback(() => {
    if (timer.current) clearTimeout(timer.current);
    setIsShowing(true);
  }, []);

  const onMouseLeave = useCallback(() => {
    timer.current = setTimeout(() => {
      setIsShowing(false);
    }, 500);
  }, []);

  return (
    <context.Provider
      value={{
        isShowing: alwaysShow || isShowing,
        onMouseEnter,
        onMouseLeave,
      }}
    >
      {children}
    </context.Provider>
  );
};
